export enum EScrollEventBlockId {
  investSberPageBenefits = 'investSberPageBenefits',
  investSberPageAffiliation = 'investSberPageAffiliation',
  investSberPageStages = 'investSberPageStages',
  investSberPageConditions = 'investSberPageConditions',
  financingOfferForm = 'financingOfferForm',
}
